<template>
  <div>
    <div class="container">
      <div class="addbox">
        <div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="toAddEssay"
            style="width:120px"
            :disabled="module_id_array[0]?!module_id_array.includes('284'):false"
          >添加文章</el-button>
        </div>
      </div>
      <div style="border: solid 1px #c9cbd6;">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;min-width:1000px;"
          :header-cell-style="{background:'#F5F5F5'}"
        >
          <el-table-column label="标题" prop="title"></el-table-column>
          <el-table-column label="作者" prop="author"></el-table-column>
          <el-table-column label="摘要" prop="summary"></el-table-column>

          <el-table-column label="编辑时间" prop="update_time"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status==1">待发布</span>
              <span v-if="scope.row.status==2">已发布</span>
              <span v-if="scope.row.status==3">已下架</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                @click="edit(scope.row.art_id,scope.row.status)"
                type="text"
                size="medium"
                :disabled="module_id_array[0]?!module_id_array.includes('283'):false"
              >详情</el-button>
              <el-button
                @click="editStatus(scope.row.art_id,3)"
                type="text"
                size="medium"
                v-if="scope.row.status==2"
              >下架</el-button>
              <el-button
                @click="editStatus(scope.row.art_id,2)"
                type="text"
                size="medium"
                v-if="scope.row.status==3||scope.row.status==1"
              >发布</el-button>
              <el-button
                @click="delexample(scope.row.art_id)"
                type="text"
                size="medium"
                :disabled="module_id_array[0]?!module_id_array.includes('284'):false"
              >删除</el-button>
            </template>
          </el-table-column>

          <el-table-column label="排序">
            <template slot-scope="scope">
              <el-button @click="updateSort(scope.row.art_id,1)" size="medium" type="text">置顶</el-button>

              <el-button @click="updateSort(scope.row.art_id,2)" size="medium" type="text">上移</el-button>
              <el-button @click="updateSort(scope.row.art_id,3)" size="medium" type="text">下移</el-button>
              <el-button @click="updateSort(scope.row.art_id,4)" size="medium" type="text">置底</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex center">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          style="margin:30px 0 20px 0"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import platform from "../../../api/platform";
import clinic from "../../../api/clinic";
export default {
  data() {
    return {
      detail: {},
      tableData: [],
      currentPage: 1,
      pagesize: 10,
      totalNum: 0
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        department_id: this.$route.query.department_id
      };
      clinic.getLibraryList(data).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.list.map(item => {
            item.update_time = platform.timestampToTime(item.update_time);
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //排序
    updateSort(art_id, sort) {
      let data = {
        art_id,
        sort,
        department_id: this.$route.query.department_id
      };

      clinic.editLibrarySort(data).then(res => {
        if (res.code == 0) {
          this.getList();
        }
      });
    },
    //添加
    toAddEssay() {
      this.$router.push({
        path: "addessay",
        query: {
          department_id: this.$route.query.department_id
        }
      });
    },
    //编辑
    edit(art_id, status) {
      let department_id = this.$route.query.department_id;
      if (status == 2) {
        this.$router.push({
          path: "essaydetail",
          query: {
            art_id,
            department_id
          }
        });
      } else {
        this.$router.push({
          path: "addessay",
          query: {
            art_id,
            department_id
          }
        });
      }
    },
    //修改状态
    editStatus(art_id, status) {
      clinic.changeLibraryStatus({ status, art_id }).then(res => {
        if (res.code == 0) {
          this.$message.success("已修改发布状态");
          this.getList();
        }
      });
    },
    //删除
    delexample(art_id) {
      this.$confirm("确定要删除吗？", "提示消息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        clinic.delLibrary({ art_id }).then(res => {
          if (res.code == 0) {
            this.$message.success("删除成功");
            this.getList();
          }
        });
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  text-align: left;
}
.addbox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
</style>

